module.exports = __webpack_public_path__ + "static/media/app_framed_tiny.728d6b6a.png";